import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CourseDetailMobRoutingModule } from './course-detail-mob-routing.module';
import { CourseDetailMobComponent } from './course-detail-mob.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { PipesModule } from 'src/app/theme/pipes/pipes.module';
import { SharedModule } from '../shared.module';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslateModule } from 'src/app/theme/translate/translate.module';
import { ProductModule } from 'src/app/pages/product/product.module';
import { ProductsModule } from 'src/app/pages/Products/Products.module';
import { MatIcon } from '@angular/material/icon';
import { LogoComponent } from 'src/app/theme/components/logo/logo.component';
import { ComponentModule } from 'src/app/theme/components/component.module';
import { MatMenuModule } from '@angular/material/menu';
import { CertificateDownloadModule } from 'src/app/pages/order/certificate-download/certificate-download.module';
import { QuizModule } from 'src/app/pages/quiz/quiz.module';
import { ReviewRatingModule } from 'src/app/pages/review-rating/review-rating.module';
import { NotesModule } from '../notes/notes.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MatCardModule } from '@angular/material/card';

@NgModule({
  declarations: [
    CourseDetailMobComponent
  ],
  imports: [
    CommonModule,
    CourseDetailMobRoutingModule,
    FlexLayoutModule,
    MatIconModule,
    MatButtonModule,
    PipesModule,
    SharedModule,
    MatTabsModule,
    TranslateModule,
    ProductModule,
    ComponentModule,
    MatMenuModule,
    CertificateDownloadModule,
    QuizModule,
    ReviewRatingModule,
    NotesModule,
    PdfViewerModule,
    MatCardModule
  ],exports:[
    CourseDetailMobComponent
  ]

})
export class CourseDetailMobModule { }
